export const userInitialState = {
    selectedChatUserDetails: {},
    selectedChatUserName: '',
};

export const usersReducer = (state = userInitialState, action = {}) => {
    switch (action.type) {
        case 'SELECTED_CHAT_USER_DETAILS': {
            return {
                ...state,
                selectedChatUserDetails: action.selectedChatUserDetails,
                selectedChatUserName: action.selectedChatUserName
            };
        }
        default: {
            return state;
        }
    }
};
